import { BaseModel } from './base.model'
import { InteractiveSkillGrade } from './interactive-skill-grade.model'
import * as _ from 'lodash'

export class InteractiveSkill extends BaseModel<InteractiveSkill> {
  static DEFAULT_ATTRIBUTES = {
  }

  id: number
  grades: InteractiveSkillGrade[]
  skillId: number
  interactiveId: number
  name: string
  weight: number

  recalcGradesThreshold():void {
   let prevGrade = null
   _.forEach(this.grades, function(grade, i){
      if(prevGrade){
        grade.minPointsCountTreshold = prevGrade.pointsCountTreshold + 1
      }else{
        grade.minPointsCountTreshold = 0
      }
      prevGrade = grade
   }) 
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/interactive-skill.model.ts